import React from 'react'
import { Container } from '@material-ui/core'

const FormContainer = ({ children, ...restProps }) => {
  return (
    <Container className="form-container" {...restProps}>
      {children}
    </Container>
  )
}

export default FormContainer
